import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Slider } from "@/components/ui/slider";
import { NewsPreferences } from "@/hooks/useNewsPreferences";

interface GeneralTabProps {
  preferences: NewsPreferences;
  onChange: (updates: Partial<NewsPreferences>) => void;
}

export const GeneralTab = ({ preferences, onChange }: GeneralTabProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div>
          <Label className="text-base font-semibold">Fetch Frequency</Label>
          <p className="text-sm text-muted-foreground mb-3">
            How often should we automatically fetch new articles?
          </p>
          <RadioGroup
            value={preferences.fetch_frequency}
            onValueChange={(value) => onChange({ fetch_frequency: value as any })}
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="manual" id="manual" />
              <Label htmlFor="manual" className="font-normal cursor-pointer">
                Manual Only - I'll fetch when I want
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="daily" id="daily" />
              <Label htmlFor="daily" className="font-normal cursor-pointer">
                Daily - Once per day
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="twice_daily" id="twice_daily" />
              <Label htmlFor="twice_daily" className="font-normal cursor-pointer">
                Twice Daily - Morning & afternoon
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="weekly" id="weekly" />
              <Label htmlFor="weekly" className="font-normal cursor-pointer">
                Weekly - Once per week
              </Label>
            </div>
          </RadioGroup>
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <Label className="text-base font-semibold">Articles Per Fetch</Label>
            <span className="text-sm font-medium text-primary">
              {preferences.max_articles_per_fetch}
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Maximum number of articles to store per fetch
          </p>
          <Slider
            value={[preferences.max_articles_per_fetch]}
            onValueChange={([value]) => onChange({ max_articles_per_fetch: value })}
            min={5}
            max={50}
            step={5}
            className="w-full"
          />
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>5</span>
            <span>50</span>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <Label className="text-base font-semibold">Minimum Relevance Score</Label>
            <span className="text-sm font-medium text-primary">
              {Math.round(preferences.min_relevance_score * 100)}%
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Articles below this threshold will be filtered out. Lower scores = more articles but less focused.
          </p>
          <Slider
            value={[preferences.min_relevance_score * 100]}
            onValueChange={([value]) => onChange({ min_relevance_score: value / 100 })}
            min={0}
            max={100}
            step={5}
            className="w-full"
          />
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>0%</span>
            <span>100%</span>
          </div>
        </div>
      </div>
    </div>
  );
};
